import React from 'react';
import { useFormContext, Controller } from 'react-hook-form';
import { SelectProps } from './types';
import Select from './index';

type Props = React.InputHTMLAttributes<HTMLInputElement> & Omit<SelectProps, "onChangeHandler"> & {
    name: string;
    helperText?: string;
    control?: any;
};

export default function RHFSelect({ name, helperText, type, ...other }: Props) {
    let { control } = useFormContext() || {};

    control = control || other.control;

    return (
        <Controller
            name={name}
            control={control}
            render={({ field, fieldState: { error } }) => (
                <div>
                    <Select
                        value={field.value}
                        onChangeHandler={(options: any) => {
                            field.onChange(options);
                        }}
                        {...other}
                    />
                    {error ? (
                        <span className='text-sm text-rejectDark pt-[5px]'>{error?.message}</span>
                    ) : (
                        <span>{helperText}</span>
                    )}
                </ div>
            )}
        />
    );
}